export default __webpack_public_path__ + "static/media/daa68393171aea5139a515ad8ece1a751581006225594.1fbefda2.webp";